// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { styled, useTheme } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
// import ViewListIcon from '@mui/icons-material/ViewList';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import Paper from '@mui/material/Paper';
import RefreshIcon from '@mui/icons-material/Refresh';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { FixedSizeList, ListChildComponentProps } from 'react-window';
import AutoSizer from "react-virtualized-auto-sizer";
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ChatIcon from '@mui/icons-material/Chat';
import InfoIcon from '@mui/icons-material/Info';

// import Draggable from 'devextreme-react/draggable';

// import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';

import * as DmsCommon from '../supports/dms-common';
import { GlobalState, GlobalEvent } from './GlobalContext'

let FOLDER_IMG = "images/foldericon1.png";
let FOLDER_CLOSED_IMG = "images/foldericon2.png";
let FOLDER_OPENED_IMG = "images/foldericon3.png";
let PERSONAL_FOLDER_IMG = "images/foldericon4.png";
let PERSONAL_FOLDER_CLOSED_IMG = "images/foldericon5.png";
let PERSONAL_FOLDER_OPENED_IMG = "images/foldericon6.png";
let LINKED_FOLDER_IMG = "images/foldericon7.png";
let LINKED_FOLDER_CLOSED_IMG = "images/foldericon8.png";
let LINKED_FOLDER_OPENED_IMG = "images/foldericon9.png";
let MONITOR_FOLDER_IMG = "images/foldericon11.png";
let MONITOR_FOLDER_CLOSED_IMG = "images/foldericon12.png";
let MONITOR_FOLDER_OPENED_IMG = "images/foldericon13.png";

let LINKED_FOLDER_RAG_IMG = "images/ai-folder-24.png";






function FolderTreeList2(props) {

  const {
    // drawerWidth,
    folders,
    selFolderID,
    compactMode,
    onChangeFolderID,
    onItemListChanged,
    onFolderInfoClick,
    disableVirtualTree,
    enableMobileAccessDisplay,

  } = props;

  const StyledBadge = styled(Badge) < BadgeProps > (({ theme }) => ({
    '& .MuiBadge-badge': {
      // right: -3,
      top: 5,
      // border: `2px solid ${theme.palette.background.paper}`,
      // padding: '0 4px',
      fontSize: compactMode ? 8 : 10,
      height: compactMode ? 12 : undefined,
      minWidth: compactMode ? 12 : undefined,
      padding: compactMode ? "0 3px" : undefined,
    },
  }));

  const [showLoading, setShowLoading] = useState(false);

  const disableAllFolder = props.disableAllFolder || false;
  const disablePersonalFolder = props.disablePersonalFolder || false;
  const disablePhyLocFolder = props.disablePhyLocFolder || false;

  const limitedRootFolderIDs = props.limitedRootFolderIDs || null;


  const disableReadCnt = props.disableReadCnt || false;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);
  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  // const disableReadCnt = (props.disableReadCnt === undefined) ? true : props.disableReadCnt;



  const [folderNodes, setFolderNodes] = useState([]);
  const [folderTree, setFolderTree] = useState([]);
  const [visibleTreeNodes, setVisibleTreeNodes] = useState([]);
  const [orderedFolderNodes, setOrderedFolderNodes] = useState([]);

  // const [listRefs, setListRefs] = useState([]);
  const listRef = React.createRef();
  // const [searchFolderID, setSearchFolderID] = useState((selFolderID == undefined) ? DmsCommon.VOID_FOLDER_ID : selFolderID);
  const [searchFolderID, setSearchFolderID] = useState(DmsCommon.VOID_FOLDER_ID);



  const getFolderImg = (AFolderNode) => {
    let vHasChild = (AFolderNode.ChildFolderList.length > 0);
    // let vHasChild = (AFolderNode.ChildCnt > 0);
    let vIsPersonalFolder = (AFolderNode.id == DmsCommon.PERSONAL_FOLDER_ID || AFolderNode.ParentID == DmsCommon.PERSONAL_FOLDER_ID);
    let vIsOpened = AFolderNode.openNode;
    let vIsLinkedFolder = (AFolderNode.LinkedFolderID != 0);
    let vIsMonitorFolder = AFolderNode.IsMonitorFolder || false;

    let vFolderImg = FOLDER_IMG;
    if (vIsPersonalFolder) {
      if (vHasChild) {
        if (vIsOpened) {
          vFolderImg = PERSONAL_FOLDER_OPENED_IMG;
        } else {
          vFolderImg = PERSONAL_FOLDER_CLOSED_IMG;
        }
      } else {
        vFolderImg = PERSONAL_FOLDER_IMG;
      }
    }
    else {
      if (vHasChild) {
        if (vIsOpened) {
          if (vIsLinkedFolder) {
            vFolderImg = LINKED_FOLDER_OPENED_IMG;
          } else if (vIsMonitorFolder) {
            vFolderImg = MONITOR_FOLDER_OPENED_IMG;
          } else {
            vFolderImg = FOLDER_OPENED_IMG;
          }
        } else {
          if (vIsLinkedFolder) {
            vFolderImg = LINKED_FOLDER_CLOSED_IMG;
          } else if (vIsMonitorFolder) {
            vFolderImg = MONITOR_FOLDER_CLOSED_IMG;
          } else {
            vFolderImg = FOLDER_CLOSED_IMG;
          }
        }
      } else {
        if (vIsLinkedFolder) {
          vFolderImg = LINKED_FOLDER_IMG;
        } else if (vIsMonitorFolder) {
          vFolderImg = MONITOR_FOLDER_IMG;
        } else {
          vFolderImg = FOLDER_IMG;
        }
      }

    }

    return vFolderImg;
  }

  function handleFolderNodeClick(AFolderNode) {
    if (AFolderNode) {
      AFolderNode.openNode = !AFolderNode.openNode;
    }

    onChangeFolderID && onChangeFolderID(AFolderNode.id);

    setFolderTree([...folderTree]);
  }



  // const onDragMove = (e) => {
  //   console.log(' onDragMove ~ e:', e);

  // }

  function folderListItem(aFolderNode) {
    let vReadCnt = 0;

    vReadCnt = disableReadCnt ? 0 : aFolderNode.UnreadCnt;
    // vReadCnt = 0;

    let vReturnTsx = (<></>)

    if (aFolderNode.id == DmsCommon.SEARCH_FOLDER_ID) {
      vReturnTsx = (
        <StyledBadge badgeContent={vReadCnt} max={999} color="primary" anchorOrigin={{ vertical: "top", horizontal: 'right', }}
          sx={{ mr: 1 }}
        >
          <SearchIcon sx={{ width: compactMode ? 16 : 24, height: compactMode ? 16 : 24 }} />
        </StyledBadge>
      )

    } else if (aFolderNode.id == DmsCommon.PHY_LOC_FOLDER_ID) {

      const vIsOpened = aFolderNode.openNode;

      vReturnTsx = (
        <StyledBadge badgeContent={0} max={999} color="primary" anchorOrigin={{ vertical: "top", horizontal: 'right', }}
          sx={{ mr: 1 }}
        >
          {vIsOpened ? <ArrowDropDownIcon sx={{
            width: compactMode ? 16 : 24, height: compactMode ? 16 : 24
          }} /> : <ArrowRightIcon sx={{
            width: compactMode ? 16 : 24, height: compactMode ? 16 : 24
          }} />}<DocumentScannerIcon sx={{
            width: compactMode ? 16 : 24, height: compactMode ? 16 : 24
          }} />
        </StyledBadge>
      )

    } else if (aFolderNode.ParentID == DmsCommon.PHY_LOC_FOLDER_ID) {
      vReturnTsx = (
        <StyledBadge badgeContent={0} max={999} color="primary" anchorOrigin={{ vertical: "top", horizontal: 'right', }}
          sx={{ mr: 1 }}
        >
          <DocumentScannerIcon sx={{
            ml: 4,
            width: compactMode ? 16 : 24,
            height: compactMode ? 16 : 24,
          }} />
        </StyledBadge>
      )
    } else {

      let vFolderImg = getFolderImg(aFolderNode);
      vReturnTsx = (
        <StyledBadge
          badgeContent={vReadCnt} max={999} color="primary" anchorOrigin={{ vertical: "top", horizontal: 'right', }}
          sx={{ mr: 1 }}
        >
          <Avatar alt="Folder"
            src={vFolderImg} variant="square" sx={{
              width: compactMode ? 16 : 24,
              height: compactMode ? 16 : 24,
            }}
          />
        </StyledBadge>
      )

    }
    return vReturnTsx;
  }

  const itemsRef = React.useRef([]);



  useEffect(() => {
    itemsRef.current = itemsRef.current.slice(0, visibleTreeNodes.length)

    onItemListChanged && onItemListChanged(itemsRef.current)
  }, [visibleTreeNodes])

  const getFileNameDisplay = (folder) => {
    // DmsCommon.ALL_FOLDER_ID && f.ParentID != DmsCommon.PERSONAL_FOLDER_ID
    let vFolderName = folder.FolderName;

    let vRag = ""

    if (enableMobileAccessDisplay &&
      (folder.ParentID === DmsCommon.ALL_FOLDER_ID ||
        folder.ParentID === DmsCommon.PERSONAL_FOLDER_ID)) {
      vFolderName += (folder.MobileAccessible === true ? "*" : "");

    }

    if (folder.RagEnabled === true) {
      vRag = (
        <Avatar
          alt="RAG"
          src={LINKED_FOLDER_RAG_IMG}
          variant="square"
          sx={{
            width: compactMode ? 14 : 18,
            height: compactMode ? 14 : 18,
            flexShrink: 0,
          }}
        />
      );
    }



    return (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <span>{vFolderName}</span>
        {vRag}
      </Box>
    );
  }

  function renderRow({ index, style }) {

    const folderNode = visibleTreeNodes[index];

    const folderName = getFileNameDisplay(folderNode);

    return (
      <ListItemButton
        dense={true}
        style={style}
        key={folderNode.id}
        ref={el => itemsRef.current[index] = { el, folderID: folderNode.id }}
        sx={{
          borderBottom: 1, borderColor: 'grey.200',
          py: compactMode ? 0 : 0.5,
          pl: 1 + 1 * folderNode.TreeLv,

        }}
        onClick={() => handleFolderNodeClick(folderNode)}
        selected={folderNode.id === selFolderID} >
        <ListItemAvatar sx={{ minWidth: 46 }}  >
          {folderListItem(folderNode)}
        </ListItemAvatar>
        <ListItemText
          primary={folderName}
          primaryTypographyProps={{
            fontSize: compactMode ? 13 : 14,
            noWrap: true,
          }}
        />
      </ListItemButton >
    )


  }



  function createListItemFolder(folderNode, idx) {

    const folderName = getFileNameDisplay(folderNode);

    // const folderName = folderNode.FolderName + "*"

    return (
      <React.Fragment key={folderNode.id} >

        <ListItemButton
          dense={true}
          key={folderNode.id}
          ref={el => itemsRef.current[idx] = { el, folderID: folderNode.id }}
          sx={{
            borderBottom: 1,
            borderColor: 'grey.200',
            py: compactMode ? 0 : 0.5,
            pl: 1 + 1 * folderNode.TreeLv,
            // py: 0, my: 0,
            height: compactMode ? 24 : 38,
          }}
          onClick={() => handleFolderNodeClick(folderNode)}
          selected={folderNode.id === selFolderID} >
          <ListItemAvatar sx={{ minWidth: compactMode ? 16 : 30 }}  >
            {folderListItem(folderNode)}
          </ListItemAvatar>
          <ListItemText
            primary={folderName}
            primaryTypographyProps={{
              fontSize: compactMode ? 13 : 14,
              noWrap: true,
            }}
          />

        </ListItemButton>


      </React.Fragment>
    )
  }



  useEffect(() => {
    // console.log("useEffect FolderTreeList2(did mounted)");

  }, [])

  const [selectedFolderNode, setSelectedFolderNode] = useState(null);




  useEffect(() => {
    // console.log("useEffect FolderTreeList[gEvent.UpdateDocUnReadCnt] ", gEvent.UpdateDocUnReadCnt);

    const { folderID, unreadCnt } = gEvent.UpdateDocUnReadCnt || {};
    if (folderID && (unreadCnt >= 0)) {
      updateFolderUnreadCnt(folderID, unreadCnt);

    }

  }, [gEvent.UpdateDocUnReadCnt])

  const updateFolderUnreadCnt = (AFolderID, AUnreadCnt) => {
    // console.log(`FolderTreeList2.updateFolderUnreadCnt ${AFolderID} ${AUnreadCnt}`);

    setFolderNodes((prevFolderNodes) => {
      const newFolderArray = prevFolderNodes.map(item => {
        const newItem = {
          ...item,
          ChildFolderList: [],
        }
        if (item.id === AFolderID) {
          // newItem.UnreadCnt = newItem.UnreadCnt-1;
          newItem.UnreadCnt = AUnreadCnt;
        }
        return newItem;

      })
      // console.log("handleAfterDocRead newFolderArray", newFolderArray);

      return newFolderArray
    });
  }

  // Refresh FolderNodes state
  useEffect(() => {
    // console.log("useEffect FolderTreeList2[folders]");

    setShowLoading(true);
    // Use short timeout to allow React to paint the loading indicator
    setTimeout(() => {

      setFolderNodes((prevFolderNodes) => {
        const prevOpenMap = new Map();
        if (prevFolderNodes && prevFolderNodes.length > 0) {
          for (let i = 0; i < prevFolderNodes.length; i++) {
            prevOpenMap.set(prevFolderNodes[i].id, prevFolderNodes[i].openNode);
          }
        }

        const nodeMap = new Map();
        let vFolderNodes = (folders || []).map(f => {
          const node = {
            id: f.id,
            ParentID: f.ParentID,
            FolderName: f.FolderName,
            FolderPath: f.FolderPath,
            LinkedFolderID: f.LinkedFolderID,
            UnreadCnt: f.UnreadCnt,
            MobileAccessible: f.MobileAccessible,
            RagEnabled: f.RagEnabled,
            IsMonitorFolder: f.IsMonitorFolder,

            ChildFolderList: [],
            openNode: prevOpenMap.get(f.id) || false,
          };
          nodeMap.set(f.id, node);
          return node;
        });

        // Add All Folder Node
        if (disableAllFolder === false) {
          if (!nodeMap.has(DmsCommon.ALL_FOLDER_ID)) {
            const vAllFolder = {
              id: DmsCommon.ALL_FOLDER_ID,
              ParentID: DmsCommon.VOID_FOLDER_ID,
              FolderName: DmsCommon.ALL_FOLDER_NAME,
              FolderPath: DmsCommon.ALL_FOLDER_NAME,
              LinkedFolderID: 0,
              UnreadCnt: 0,
              ChildFolderList: [],
              openNode: true,
              TreeLv: 0,
            };
            vFolderNodes.push(vAllFolder);
            nodeMap.set(DmsCommon.ALL_FOLDER_ID, vAllFolder);
          }
        }

        // Add Personal Folder Node
        if (disablePersonalFolder === false) {
          if (!nodeMap.has(DmsCommon.PERSONAL_FOLDER_ID)) {
            const vPersonalFolder = {
              id: DmsCommon.PERSONAL_FOLDER_ID,
              ParentID: DmsCommon.ALL_FOLDER_ID,
              FolderName: DmsCommon.PERSONAL_FOLDER_NAME,
              FolderPath: DmsCommon.PERSONAL_FOLDER_NAME,
              LinkedFolderID: 0,
              UnreadCnt: 0,
              ChildFolderList: [],
              openNode: false,
              TreeLv: 0,
            };
            vFolderNodes.unshift(vPersonalFolder);
            nodeMap.set(DmsCommon.PERSONAL_FOLDER_ID, vPersonalFolder);
          }
        }

        // Remove Physical Folder Node
        if (disablePhyLocFolder === true) {
          vFolderNodes = vFolderNodes.filter(n => n.id !== DmsCommon.PHY_LOC_FOLDER_ID);
        }

        // Open ancestor nodes for the selected folder in O(depth) steps
        if (selFolderID && nodeMap.has(selFolderID)) {
          let curr = nodeMap.get(selFolderID);
          while (curr && curr.ParentID) {
            const parent = nodeMap.get(curr.ParentID);
            if (parent) {
              parent.openNode = true;
            }
            curr = parent;
          }
        }

        return vFolderNodes;
      });

      setShowLoading(false);
    }, 10);

  }, [folders]);


  // Refresh FolderTree state
  useEffect(() => {
    let vFolderTree = [];
    const limitedSet = (limitedRootFolderIDs && Array.isArray(limitedRootFolderIDs))
      ? new Set(limitedRootFolderIDs)
      : null;

    const nodeMap = new Map();
    for (let i = 0; i < folderNodes.length; i++) {
      const f = folderNodes[i];
      f.ChildFolderList = [];
      nodeMap.set(f.id, f);
    }

    const vAllFolderNode = nodeMap.get(DmsCommon.ALL_FOLDER_ID);
    const vPersonalRootFolderNode = nodeMap.get(DmsCommon.PERSONAL_FOLDER_ID);

    // For All Folder
    if (vAllFolderNode) {
      vFolderTree.push(vAllFolderNode);
    }

    // For Personal Folder
    if (vPersonalRootFolderNode) {
      if (vAllFolderNode) {
        vAllFolderNode.ChildFolderList.push(vPersonalRootFolderNode);
      } else {
        vFolderTree.push(vPersonalRootFolderNode);
      }
    }

    // Link Parent and Child Folders in a single O(N) pass
    for (let i = 0; i < folderNodes.length; i++) {
      const f = folderNodes[i];
      if (f.id === DmsCommon.ALL_FOLDER_ID || f.id === DmsCommon.PERSONAL_FOLDER_ID) {
        continue;
      }

      if (f.ParentID === DmsCommon.PERSONAL_FOLDER_ID) {
        if (limitedSet !== null && !limitedSet.has(f.id)) {
          continue;
        }
        if (vPersonalRootFolderNode) {
          vPersonalRootFolderNode.ChildFolderList.push(f);
        } else if (vAllFolderNode) {
          vAllFolderNode.ChildFolderList.push(f);
        } else {
          vFolderTree.push(f);
        }
      } else if (f.ParentID === DmsCommon.ALL_FOLDER_ID) {
        if (limitedSet !== null && !limitedSet.has(f.id)) {
          continue;
        }
        if (vAllFolderNode) {
          vAllFolderNode.ChildFolderList.push(f);
        } else {
          vFolderTree.push(f);
        }
      } else {
        const vParentFolderNode = nodeMap.get(f.ParentID);
        if (vParentFolderNode) {
          vParentFolderNode.ChildFolderList.push(f);
        }
      }
    }

    setFolderTree(vFolderTree);

  }, [folderNodes, limitedRootFolderIDs]);


  useEffect(() => {
    // console.log("useEffect FolderTreeList2[selFolderID, folderNodes]");

    const n = folderNodes.find(n => n.id === selFolderID);
    // console.log("selectedFolderNode", n);

    setSelectedFolderNode(n);

  }, [selFolderID, folderNodes]);

  useEffect(() => {
    // console.log("useEffect FolderTreeList2[folderTree]");


    // Set the ordered nodes for searching
    let vOrderNodes = [];
    // Create the recursive function
    const xRecursiveAddNode = (aNode) => {
      vOrderNodes.push(aNode);

      aNode.ChildFolderList.forEach(node => xRecursiveAddNode(node))
    }

    // console.log("xRecursiveAddOrderNode")
    // console.time();
    folderTree.forEach(node => xRecursiveAddNode(node));
    // console.log("vOrderNodes", vOrderNodes);
    setOrderedFolderNodes(vOrderNodes);
    // console.timeEnd();


    // Set the nodes for display in list
    let vVisibleNodes = [];
    // Create the recursive function
    const xRecursiveAddVisibleNode = (aNode, aLv) => {
      aNode.TreeLv = aLv;
      vVisibleNodes.push(aNode);

      if (aNode.openNode === true) {
        aNode.ChildFolderList.forEach(node => xRecursiveAddVisibleNode(node, aLv + 1))
      }
    }

    // console.log("xRecursiveAddVisibleNode")
    // console.time();
    folderTree.forEach(i => xRecursiveAddVisibleNode(i, 0));
    // console.timeEnd();

    // console.log("vVisibleNodes", vVisibleNodes);

    // console.log("setVisibleTreeNodes")
    // console.time();
    setVisibleTreeNodes(vVisibleNodes);
    // console.timeEnd();

  }, [folderTree]);

  useEffect(() => {
    scrollToFolderItem(searchFolderID);
    setSearchFolderID(DmsCommon.VOID_FOLDER_ID);
  }, [visibleTreeNodes]);


  const scrollToFolderItem = (aFolderID) => {
    if (aFolderID !== DmsCommon.VOID_FOLDER_ID) {
      const vIdx = visibleTreeNodes.findIndex(f => f.id === aFolderID);

      // console.log("listRef", listRef);
      // console.log("listRef.current", listRef.current);

      if (vIdx > -1) {
        try {
          // listRef.current?.scrollToItem(vIdx, "center");
          listRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        } catch (e) {
          console.log(`scrollToFolderItem e`, e);
        }
      }

    }
  };





  const handleKeyDown = (e) => {
    if (e.keyCode == 13) {
      handleSearchForwardClick();
    }
  };

  const [searchText, setSearchText] = useState("");

  const handleChangeSearchText = (event) => {
    setSearchText(event.target.value);
  };

  const handleSearchPrevClick = () => {
    searchNodeByText(false);
  };

  const handleSearchForwardClick = () => {
    searchNodeByText(true);
  };



  const searchNodeByText = (aForward) => {
    const vSearchText = searchText.toLowerCase().trim();
    if (vSearchText == "") return;
    // console.log("vSearchText", vSearchText);

    const vStartIdx = orderedFolderNodes.findIndex(n => n.id === selFolderID);
    // const vStartFolder = orderedFolderNodes[vStartIndex];
    // console.log("vStartFolder", vStartFolder);
    const vLastIdx = orderedFolderNodes.length - 1;

    // console.log("vStartIdx", vStartIdx);
    // console.log("vLastIdx", vLastIdx);


    let vRstFolderID = -1;
    let vSearchList = [];
    let vSearchFolder;

    if (aForward === true) {
      if (vStartIdx == vLastIdx) return;

      vSearchList = orderedFolderNodes.slice(vStartIdx + 1);
    } else {
      if (vStartIdx == 0) return;

      vSearchList = orderedFolderNodes.slice(0, vStartIdx).reverse();
    }

    // console.log("vSearchList", vSearchList);

    vSearchFolder = vSearchList.find(f => f.FolderName?.toLowerCase().includes(vSearchText));
    // console.log("vSearchFolder", vSearchFolder);


    // Open nodes for the selected folder
    if (vSearchFolder) {
      onChangeFolderID && onChangeFolderID(vSearchFolder.id);
      // console.log("newFolderArray", newFolderArray);
      // setFolderNodes(newFolderArray);

      selectAndOpenToNode(vSearchFolder.id);
    } else {
      scrollToFolderItem(selFolderID);
    }


  };

  const selectAndOpenToNode = (AFolderID) => {
    setFolderNodes((prevFolderNodes) => {
      const nodeMap = new Map();
      for (let i = 0; i < prevFolderNodes.length; i++) {
        nodeMap.set(prevFolderNodes[i].id, prevFolderNodes[i]);
      }

      const vNode = nodeMap.get(AFolderID);
      if (vNode) {
        const vInvolvedFolders = new Set();
        let curr = vNode;
        while (curr && curr.ParentID) {
          vInvolvedFolders.add(curr.ParentID);
          curr = nodeMap.get(curr.ParentID);
        }

        setSearchFolderID(AFolderID);

        const vNewFolderNodes = prevFolderNodes.map(item => {
          const newItem = {
            ...item,
            ChildFolderList: [],
          };

          if (vInvolvedFolders.has(item.id)) {
            newItem.openNode = true;
          }

          return newItem;
        });

        return vNewFolderNodes;
      }
      return prevFolderNodes;
    });
  };

  const isSelPhyLocFolder = useMemo(() => {
    if (!selFolderID || !folders || folders.length === 0) return false;
    const vSelFolder = folders.find(f => f.id === selFolderID);
    if (vSelFolder) {
      if (vSelFolder.IsPhyLocFolder === true) return true;
      const vParentFolder = folders.find(f => f.id === vSelFolder.ParentID);
      return vParentFolder?.IsPhyLocFolder === true;
    }
    return false;
  }, [folders, selFolderID]);

  var infoBtnOpts = {}
  if (onFolderInfoClick) {
    if (isSelPhyLocFolder || selFolderID == DmsCommon.SEARCH_FOLDER_ID) {
      infoBtnOpts["display"] = 'none';
    } else {
      infoBtnOpts["display"] = 'flex';
    }
  } else {
    infoBtnOpts["display"] = 'none';
  }


  const handleInfoClick = () => {

    onFolderInfoClick && onFolderInfoClick()
  }

  return (
    <React.Fragment>
      <CssBaseline />

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Box sx={{ display: 'flex', width: "50%", height: '100%', minHeight: 0, overflow: 'hidden', flexDirection: 'column', flexGrow: 1, p: 0 }} >

        <TextField
          label="Search Folder"
          size="small"
          sx={{ m: 1, width: "94%", flexShrink: 0 }}
          value={searchText}
          onChange={handleChangeSearchText}
          onKeyDown={handleKeyDown}
          InputLabelProps={{ shrink: true, }}
          InputProps={{
            endAdornment:
              <InputAdornment position="end">
                <IconButton
                  onClick={handleSearchPrevClick}
                  onMouseDown={(event) => event.preventDefault()}
                >
                  <KeyboardArrowLeftIcon />
                </IconButton>
                <IconButton
                  onClick={handleSearchForwardClick}
                  onMouseDown={(event) => event.preventDefault()}
                  edge="end"
                >
                  <KeyboardArrowRightIcon />
                </IconButton>

              </InputAdornment>
          }}
        />



        <Box sx={{
          // py: 1,
          flex: '1 1 0px',
          minHeight: 0,
          // maxHeight: "50vh",
          overflow: 'auto',
          overscrollBehavior: 'contain',
          WebkitOverflowScrolling: 'touch',
        }} >
          {disableVirtualTree && (
            <List
              dense={true}
              ref={listRef}
              sx={{ p: 0 }}
            >
              {(visibleTreeNodes || []).map((folderNode, idx) => {
                // console.log("generate folderTree", folderTree)
                return createListItemFolder(folderNode, idx)
              }
              )}
            </List>
          )}

          {!disableVirtualTree && (
            <AutoSizer >
              {({ height, width }) => (

                <FixedSizeList
                  ref={listRef}
                  sx={{ p: 0 }}
                  className="tree-list"

                  height={height}
                  width={width}
                  itemSize={37}
                  itemCount={visibleTreeNodes.length}
                  overscanCount={5}
                >
                  {renderRow}
                </FixedSizeList>

              )}
            </AutoSizer>
          )}


        </Box>


        <TextField
          label="Selected Folder"
          size="small"
          sx={{
            m: 1, width: "94%", flexShrink: 0,
            "& .MuiInputBase-input": {
              fontSize: compactMode ? 11 : 16,
            },
          }}
          value={selectedFolderNode ? selectedFolderNode.FolderPath : ""}
          variant="filled"
          disabled
          InputLabelProps={{ shrink: true, }}
          InputProps={{
            endAdornment:
              <InputAdornment position="end" sx={{ ...infoBtnOpts }} >
                <IconButton
                  onClick={handleInfoClick}
                  onMouseDown={(event) => event.preventDefault()}
                >
                  <InfoIcon />
                </IconButton>
              </InputAdornment>
          }}
        />

      </Box>

    </React.Fragment>

  );

}


FolderTreeList2.propTypes = {
  // drawerWidth: PropTypes.number,
  folders: PropTypes.array,
  limitedRootFolderIDs: PropTypes.array,
  // selDept: PropTypes.object,
  selFolderID: PropTypes.number,
  // onDeptListClick: PropTypes.func,
  compactMode: PropTypes.bool,
  disableReadCnt: PropTypes.bool,
  disableAllFolder: PropTypes.bool,
  disablePersonalFolder: PropTypes.bool,
  disablePhyLocFolder: PropTypes.bool,
  disableVirtualTree: PropTypes.bool,
  enableMobileAccessDisplay: PropTypes.bool,
  onChangeFolderID: PropTypes.func,
  onItemListChanged: PropTypes.func,
  onFolderInfoClick: PropTypes.func,

};

// export default React.forwardRef(FolderTreeList2)
export default FolderTreeList2